import React from 'react'
import {concatenate} from "../../services/string";
import {StatusIndicator} from "./StatusIndicator";

// COnstants ----

const activeClasses = 'text-gray-900 font-medium';
const inactiveClasses = 'text-gray-500';
const completedClasses = 'text-gray-500';

// Types ----

type StepProps = {
  number: number;
  status: 'active' | 'inactive' | 'completed';
}

// Component ----

function Step({number = 1, status}: StepProps) {
  return (
    <li className={concatenate(
      'flex gap-2 items-center text-sm py-3 flex-shrink-0 pr-6',
      'lg:border-r lg:border-gray-300',
      status === 'active' && activeClasses,
      status === 'inactive' && inactiveClasses,
      status === 'completed' && completedClasses,
    )}>
      <StatusIndicator status={status} />
      <p>Step {number}</p>
    </li>
  );
}

export {Step};